import { Injectable, Component, Input, EventEmitter, Output } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalOptions } from './models/modal-options.model';

@Injectable()
@Component({
    selector: 'modal-content-base',
    template: `<div>base template -- override the template in your child component.</div>`
})
export class ModalContent {
    @Input() public modalDialogInfo: NgbModalRef;
    @Input() public modalOptions: ModalOptions;

    constructor() { };

    public onClick($event: Event): void {
        // do nothing...
        $event.stopPropagation();
        $event.preventDefault();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/modal-content.component.ts